import { getI18n } from 'react-i18next';

export const VALIDATION_ALL_BIDS_REPORT_EMPTY_DELIVERY_YEAR = 'validation.allBidsReport.emptyDeliveryYear';
export const VALIDATION_ALL_BIDS_REPORT_INVALID_DELIVERY_YEAR = 'validation.allBidsReport.invalidDeliveryYear';
export const VALIDATION_ALL_BIDS_REPORT_NOT_EMPTY_MEMBER = 'validation.allBidsReport.notEmptyMember';
export const VALIDATION_ALL_BIDS_REPORT_EMPTY_MEMBER = 'validation.allBidsReport.emptyMember';
export const VALIDATION_ALL_BIDS_REPORT_INVALID_MEMBER = 'validation.allBidsReport.invalidMember';
export const VALIDATION_AUCTION_OVERVIEW_REPORT_EMPTY_DELIVERY_YEAR = 'validation.auctionOverviewReport.emptyDeliveryYear';
export const VALIDATION_AUCTION_OVERVIEW_REPORT_INVALID_DELIVERY_YEAR = 'validation.auctionOverviewReport.invalidDeliveryYear';
export const VALIDATION_AUCTION_RESULT_REPORT_EMPTY_AUCTION_ID = 'validation.auctionResultReport.emptyAuctionId';
export const VALIDATION_AUCTION_RESULT_REPORT_INVALID_AUCTION_ID = 'validation.auctionResultReport.invalidAuctionId';
export const VALIDATION_AUCTION_RESULT_REPORT_NOT_EMPTY_MEMBER = 'validation.auctionResultReport.notEmptyMember';
export const VALIDATION_AUCTION_RESULT_REPORT_EMPTY_MEMBER = 'validation.auctionResultReport.emptyMember';
export const VALIDATION_AUCTION_RESULT_REPORT_INVALID_MEMBER = 'validation.auctionResultReport.invalidMember';
export const VALIDATION_BIDDERS_RESULT_REPORT_EMPTY_AUCTION_ID = 'validation.biddersResultReport.emptyAuctionId';
export const VALIDATION_BIDDERS_RESULT_REPORT_INVALID_AUCTION_ID = 'validation.biddersResultReport.invalidAuctionId';
export const VALIDATION_ORDER_REPORT_EMPTY_AUCTION_ID = 'validation.orderReport.emptyAuctionId';
export const VALIDATION_ORDER_REPORT_INVALID_AUCTION_ID = 'validation.orderReport.invalidAuctionId';
export const VALIDATION_TRADE_REPORT_EMPTY_AUCTION_ID = 'validation.tradeReport.emptyAuctionId';
export const VALIDATION_TRADE_REPORT_INVALID_AUCTION_ID = 'validation.tradeReport.invalidAuctionId';
export const VALIDATION_EXTENDED_TRADE_REPORT_EMPTY_AUCTION_ID = 'validation.extendedTradeReport.emptyAuctionId';
export const VALIDATION_EXTENDED_TRADE_REPORT_INVALID_AUCTION_ID = 'validation.extendedTradeReport.invalidAuctionId';
export const VALIDATION_MARKET_AUCTION_REPORT_EMPTY_AUCTION_ID = 'validation.marketAuctionReport.emptyAuctionId';
export const VALIDATION_MARKET_AUCTION_REPORT_INVALID_AUCTION_ID = 'validation.marketAuctionReport.invalidAuctionId';
export const VALIDATION_PRIMARY_MARKET_AUCTION_REPORT_EMPTY_AUCTION_ID = 'validation.primaryAuctionReport.emptyAuctionId';
export const VALIDATION_PRIMARY_MARKET_AUCTION_REPORT_INVALID_AUCTION_ID = 'validation.primaryAuctionReport.invalidAuctionId';
export const VALIDATION_AUCTION_CALENDAR_REPORT_DATE_FROM_AFTER_DATE_TO = 'validation.auctionCalendarReport.dateFromAfterDateTo';
export const VALIDATION_AUCTION_CALENDAR_REPORT_EMPTY_DATE_FROM = 'validation.auctionCalendarReport.emptyDateFrom';
export const VALIDATION_AUCTION_CALENDAR_REPORT_EMPTY_DATE_TO = 'validation.auctionCalendarReport.emptyDateTo';
export const VALIDATION_AUCTION_MARKET_DATA_REPORT_EMPTY_AUCTION_ID = 'validation.auctionMarketDataReport.emptyAuctionId';
export const VALIDATION_AUCTION_MARKET_DATA_REPORT_INVALID_AUCTION_ID = 'validation.auctionMarketDataReport.invalidAuctionId';
export const VALIDATION_AUCTION_REPORT_EMPTY_AUCTION_ID = 'validation.auctionReport.emptyAuctionId';
export const VALIDATION_AUCTION_REPORT_INVALID_AUCTION_ID = 'validation.auctionReport.invalidAuctionId';
export const ERROR_REPORT_CREATION_FAILED = 'error.report.creationFailed';
export const ERROR_REPORT_CANNOT_BE_CREATED = 'error.report.cannotBeCreated';

export const createReportErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) { // NOSONAR javascript:S1479
        case VALIDATION_ALL_BIDS_REPORT_EMPTY_DELIVERY_YEAR:
            result = i18n.t('reports.error.all-bids-report.empty-delivery-year');
            break;
        case VALIDATION_ALL_BIDS_REPORT_INVALID_DELIVERY_YEAR:
            result = i18n.t('reports.error.all-bids-report.invalid-delivery-year');
            break;
        case VALIDATION_ALL_BIDS_REPORT_NOT_EMPTY_MEMBER:
            result = i18n.t('reports.error.all-bids-report.not-empty-member');
            break;
        case VALIDATION_ALL_BIDS_REPORT_EMPTY_MEMBER:
            result = i18n.t('reports.error.all-bids-report.empty-member');
            break;
        case VALIDATION_ALL_BIDS_REPORT_INVALID_MEMBER:
            result = i18n.t('reports.error.all-bids-report.invalid-member');
            break;
        case VALIDATION_AUCTION_OVERVIEW_REPORT_EMPTY_DELIVERY_YEAR:
            result = i18n.t('reports.error.auction-overview-report.empty-delivery-year');
            break;
        case VALIDATION_AUCTION_OVERVIEW_REPORT_INVALID_DELIVERY_YEAR:
            result = i18n.t('reports.error.auction-overview-report.invalid-delivery-year');
            break;
        case VALIDATION_AUCTION_RESULT_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.auction-result-report.empty-auction-id');
            break;
        case VALIDATION_AUCTION_RESULT_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.auction-result-report.invalid-auction-id');
            break;
        case VALIDATION_AUCTION_RESULT_REPORT_NOT_EMPTY_MEMBER:
            result = i18n.t('reports.error.auction-result-report.not-empty-member');
            break;
        case VALIDATION_AUCTION_RESULT_REPORT_EMPTY_MEMBER:
            result = i18n.t('reports.error.auction-result-report.empty-member');
            break;
        case VALIDATION_AUCTION_RESULT_REPORT_INVALID_MEMBER:
            result = i18n.t('reports.error.auction-result-report.invalid-member');
            break;
        case VALIDATION_BIDDERS_RESULT_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.bidders-result-report.empty-auction-id');
            break;
        case VALIDATION_BIDDERS_RESULT_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.bidders-result-report.invalid-auction-id');
            break;
        case VALIDATION_ORDER_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.order-report.empty-auction-id');
            break;
        case VALIDATION_ORDER_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.order-report.invalid-auction-id');
            break;
        case VALIDATION_TRADE_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.trade-report.empty-auction-id');
            break;
        case VALIDATION_TRADE_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.trade-report.invalid-auction-id');
            break;
        case VALIDATION_EXTENDED_TRADE_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.extended-trade-report.empty-auction-id');
            break;
        case VALIDATION_EXTENDED_TRADE_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.extended-trade-report.invalid-auction-id');
            break;
        case VALIDATION_MARKET_AUCTION_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.market-auction-report.empty-auction-id');
            break;
        case VALIDATION_MARKET_AUCTION_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.market-auction-report.invalid-auction-id');
            break;
        case VALIDATION_PRIMARY_MARKET_AUCTION_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.primary-auction-report.empty-auction-year');
            break;
        case VALIDATION_PRIMARY_MARKET_AUCTION_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.primary-auction-report.invalid-auction-year');
            break;
        case VALIDATION_AUCTION_CALENDAR_REPORT_DATE_FROM_AFTER_DATE_TO:
            result = i18n.t('reports.error.auction-calendar-report.date-from-after-date-to');
            break;
        case VALIDATION_AUCTION_CALENDAR_REPORT_EMPTY_DATE_FROM:
            result = i18n.t('reports.error.auction-calendar-report.empty-date-from');
            break;
        case VALIDATION_AUCTION_CALENDAR_REPORT_EMPTY_DATE_TO:
            result = i18n.t('reports.error.auction-calendar-report.empty-date-to');
            break;
        case VALIDATION_AUCTION_MARKET_DATA_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.auction-market-data-report.empty-auction-id');
            break;
        case VALIDATION_AUCTION_MARKET_DATA_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.auction-market-data-report.invalid-auction-id');
            break;
        case VALIDATION_AUCTION_REPORT_EMPTY_AUCTION_ID:
            result = i18n.t('reports.error.auction-report.empty-auction-id');
            break;
        case VALIDATION_AUCTION_REPORT_INVALID_AUCTION_ID:
            result = i18n.t('reports.error.auction-report.invalid-auction-id');
            break;
        case ERROR_REPORT_CREATION_FAILED:
            result = i18n.t('reports.error.creation-failed');
            break;
        case ERROR_REPORT_CANNOT_BE_CREATED:
            result = i18n.t('reports.error.cannot-be-created');
            break;
        default:
            result = undefined;
    }
    return result;
};
